<template>
  <li
    class="tw:gap-x-3 tw:bg-white tw:flex tw:px-4 tw:py-3 tw:border-b tw:border-gray-300 tw:last:border-0 tw:first:rounded-t-xl tw:last:rounded-b-xl tw:items-center"
    data-testid="hotel-offer-past-offers-element"
  >
    <img class="tw:h-[40px] tw:w-[40px]" :src="pastOfferIcon" :alt="$t(`ho_${pastOffer.template}_title`)" />
    <div class="tw:gap-y-1 tw:w-full">
      <p class="tw:text-sm tw:text-gray-800">{{ $t(`ho_${pastOffer.template}_title`) }}</p>
      <div class="tw:flex tw:items-center tw:gap-x-1">
        <p class="tw:text-xs tw:text-gray-600 tw:w-1/6">
          <span v-if="offerPublishingDate" data-testid="hotel-offers-past-item-valid-from"
            >{{ `${$t('hotel_offers_valid_from')} ` }}{{ offerPublishingDate }}</span
          >
        </p>
        <p class="tw:text-xs tw:text-gray-600 tw:w-1/6">
          <span v-if="expirationDate" data-testid="hotel-offers-past-item-valid-until"
            >{{ `${$t('hotel_offers_valid_until')} ` }}{{ expirationDate }}</span
          >
        </p>
        <p class="tw:text-xs tw:text-gray-600 tw:w-4/6">
          <span
            v-if="templateType === 'DISCOUNT' && pastOffer.benefitValue !== null"
            data-testid="hotel-offers-past-item-discounted"
            >{{ `${$t('hotel_offers_discounted')} ` }}{{ discountFormatted }}</span
          >
          <span v-if="templateType === 'DISCOUNT' && pastOffer.benefitValue === null">{{
            `${$t('hotel_offers_free')}`
          }}</span>
        </p>
      </div>
    </div>
  </li>
</template>
<script setup>
import { computed } from 'vue'

import { useOffersTemplates } from '@/components/hotelOffers/queries/index.js'
import { selectedAccommodationId } from '@/layouts/queries'
import { useFormatting } from '@/composables/useFormatting'

const pastOfferIcon = new URL(`../../assets/img/hotel-offers/icons/UI/past-offer.png`, import.meta.url)

const props = defineProps({
  pastOffer: Object,
})
const { formatDate, formatPercentage } = useFormatting()
const { templates } = useOffersTemplates(selectedAccommodationId)

const offerPublishingDate = computed(() => {
  if (!props.pastOffer?.publishingDate) return null

  const publishingDate = props.pastOffer?.publishingDate.replace('@', 'T')
  return formatDate(new Date(publishingDate), {
    timeZone: 'UTC',
  })
})

const expirationDate = computed(() => {
  if (!props.pastOffer?.effectiveEndDate) return null

  const effectiveEndDate = props.pastOffer?.effectiveEndDate.replace('@', 'T')
  return formatDate(new Date(effectiveEndDate), {
    timeZone: 'UTC',
  })
})

const templateType = computed(() => {
  const currentTemplate = templates.value?.find(item => item.name === props.pastOffer.template)

  return currentTemplate?.type
})

const discountFormatted = computed(() => formatPercentage(props.pastOffer?.benefitValue, 0, 0))
</script>
